module.exports = __webpack_public_path__ + "img/ksc-logo.03a8605e.png";